import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from "../../shared/shared.module";
import {MaterialModule} from "../../shared/material-module";
import {StoreModule} from "@ngrx/store";
import {reducer} from "./core/sessions-list.reducer";
import {EffectsModule} from "@ngrx/effects";
import {SessionsListEffects} from "./core/sessions-list.effects";
import {SessionsListTableComponent} from './components/sessions-list-table/sessions-list-table.component';
import {InfiniteScrollModule} from "ngx-infinite-scroll";
import {SessionRescheduleComponent} from './components/session-reschedule/session-reschedule.component';
import {SessionDetailsComponent} from './components/session-details/session-details.component';
import {SessionResourcesComponent} from './components/session-resources/session-resources.component';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import { IndividualSessionDetailsComponent } from './components/individual-session-details/individual-session-details.component';
import { UserDetailsComponent } from './components/user-details/user-details.component';
import { UserComponent } from './components/user/user.component';
import { UserAttendanceComponent } from './components/user-attendance/user-attendance.component';
import { HeadingLoaderComponent } from './components/loaders/heading-loader/heading-loader.component';
import { FoodJournalingLoaderComponent } from './components/loaders/food-journaling-loader/food-journaling-loader.component';
import { ScheduleLoaderComponent } from './components/loaders/schedule-loader/schedule-loader.component';


@NgModule({
  declarations: [
    SessionDetailsComponent,
    SessionResourcesComponent,
    SessionsListTableComponent,
    SessionRescheduleComponent,
    IndividualSessionDetailsComponent,
    UserDetailsComponent,
    UserComponent,
    UserAttendanceComponent,
    HeadingLoaderComponent,
    FoodJournalingLoaderComponent,
    ScheduleLoaderComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    StoreModule.forFeature("ss-cord.sessions-list", reducer),
    EffectsModule.forFeature(
      [SessionsListEffects]
    ),
    FormsModule,
    ReactiveFormsModule,
    InfiniteScrollModule,
    InfiniteScrollModule,
  ]
})
export class SessionsListModule {
}
